import React, { useState } from 'react';
import { motion } from 'framer-motion';
import './Contact.css';
import { addForm } from '../api/gwform.js';
import { message } from 'antd';
import MapComponent from '../components/MapComponent.jsx';

const Contact = () => {


  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    firmName: '',
    content: '',
    source: '星晟官网',
  })

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('Form submitted with data:', formData); // 添加日志以便调试
    try {
      // 这里可以添加表单提交逻辑
      await addForm(formData);
      message.success('提交成功');
      setFormData({
        name: '',
        phone: '',
        email: '',
        firmName: '',
        content: '',
        source: '星晟官网',
      });
    } catch (error) {
      console.error('Submission error:', error);
      message.error('提交失败，请重试');
    }
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };


  return (
    <div className="contact">
      <motion.section
        className="hero"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
      >
        <div className="container">
          <motion.h1
            initial={{ y: 30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            联系我们
          </motion.h1>
        </div>
      </motion.section>

      <motion.section
        className="contact-content"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, margin: "0px 0px -100px 0px" }}
        transition={{ duration: 0.8 }}
      >
        <div className="container">
          <div className="contact-grid">
            <motion.div
              className="contact-info"
              initial={{ x: -30, opacity: 0 }}
              whileInView={{ x: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              <h2>联系方式</h2>
              <div className="info-item">
                <h3>咨询热线</h3>
                <p>139-5780-8808</p>
              </div>
              <div className="info-item">
                <h3>邮箱</h3>
                <p>shidao@yuezhong.com</p>
              </div>
              <div className="info-item">
                <h3>地址</h3>
                <p>宁波市高新区创苑路750号软件园D座8楼</p>
              </div>
              <div className="info-item">
                <h3>工作时间</h3>
                <p>周一至周五 9:00-18:00</p>
              </div>

              <div className="map">
                <h3>公司位置</h3>
                <div className="map-placeholder">
                  <MapComponent />
                </div>
              </div>
            </motion.div>

            <motion.div
              className="contact-form"
              initial={{ x: 30, opacity: 0 }}
              whileInView={{ x: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.3 }}
            >
              <h2>在线留言</h2>
              <form onSubmit={handleSubmit}>
                <motion.div
                  className="form-group"
                  initial={{ y: 20, opacity: 0 }}
                  whileInView={{ y: 0, opacity: 1 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: 0.4 }}
                >
                  <label htmlFor="name">姓名</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </motion.div>

                <motion.div
                  className="form-group"
                  initial={{ y: 20, opacity: 0 }}
                  whileInView={{ y: 0, opacity: 1 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: 0.45 }}
                >
                  <label htmlFor="email">邮箱</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </motion.div>

                <motion.div
                  className="form-group"
                  initial={{ y: 20, opacity: 0 }}
                  whileInView={{ y: 0, opacity: 1 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: 0.5 }}
                >
                  <label htmlFor="phone">电话</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                  />
                </motion.div>

                <motion.div
                  className="form-group"
                  initial={{ y: 20, opacity: 0 }}
                  whileInView={{ y: 0, opacity: 1 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: 0.55 }}
                >
                  <label htmlFor="firmName">公司</label>
                  <input
                    type="text"
                    id="firmName"
                    name="firmName"
                    value={formData.firmName}
                    onChange={handleChange}
                  />
                </motion.div>

                <motion.div
                  className="form-group"
                  initial={{ y: 20, opacity: 0 }}
                  whileInView={{ y: 0, opacity: 1 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: 0.6 }}
                >
                  <label htmlFor="content">留言内容</label>
                  <textarea
                    id="content"
                    name="content"
                    rows="5"
                    value={formData.content}
                    onChange={handleChange}
                    required
                  ></textarea>
                </motion.div>

                <motion.div
                  type="submit"
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  initial={{ y: 20, opacity: 0 }}
                  whileInView={{ y: 0, opacity: 1 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: 0.65 }}
                >
                  <button className="submit-button" type="submit">发送留言</button>
                </motion.div>
              </form>
            </motion.div>
          </div>
        </div>
      </motion.section>
    </div>
  );
};

export default Contact;